import { Injectable } from '@angular/core';
import { FpConfigurationDto } from 'webcommon/shared';
import { FpConfigurationRepository } from 'webcommon/webapi';

@Injectable({
  providedIn: 'root',
})
export class FpConfigurationService {

  defaultExtensions =  '.tif, .tiff, .jpeg, .jpg, .jif, .jfif, .jp2, .jpx,' +
  '.j2k, .j2c, .fpx, .png, .pdf, .doc, .docx, .dot, .dotx, .text, .txt, .xls, .xlsx, .xla, .xltx';
  defaultNumber = 5;
  defaultSize = 200;
  hasError = false;
  isLoading = false;

  configuration: FpConfigurationDto = {
    AllowedAttachmentExtensions: this.defaultExtensions,
    AttachmentNumberLimit: 5,
    AttachmentSizeLimit: this.defaultSize,
    UsersAndUserGroups: [],
  };

  constructor(
    private fpConfigurationRepository: FpConfigurationRepository,
  ) { }

  loadFpConfiguration() {
    this.isLoading = true;
    this.fpConfigurationRepository.getFacilityPortalConfiguration().subscribe((result) => {
      this.configuration = result;
    }, () => {
      this.hasError = true;
    }, () => {
      this.isLoading = false;
    });
  }

  getAllowedAttachmentExtensions() {
    let extensions = this.defaultExtensions;

    if (this.configuration.AllowedAttachmentExtensions && this.configuration.AllowedAttachmentExtensions !== '') {
      extensions = this.configuration.AllowedAttachmentExtensions;
    }

    return extensions;
  }

  getAttachmentSizeLimit() {
    if (this.configuration.AttachmentSizeLimit) {
      return this.configuration.AttachmentSizeLimit;
    }

    return this.defaultSize;
  }

  getMaxFiles() {
    if (this.configuration.AttachmentNumberLimit) {
      return this.configuration.AttachmentNumberLimit;
    }

    return this.configuration.AttachmentNumberLimit;
  }
}
